import { FC, useState } from 'react';

import { Form, Select } from 'antd';
import { Input, Label } from 'ui';
import { formRules } from 'utils/formRules';

import { EventTicketType } from 'types/events/eventTypes';
import { OfferType } from 'types/promoters/promoterTypes';

import EventOfferSetTicketType from '../event-offer-set-ticket-type';
import s from './EventOfferPerMultipleTickets.module.scss';

interface EventOfferPerMultipleTicketsProps {
  tickets?: EventTicketType[];
  ticketTypes?: {
    ticketType?: EventTicketType;
    ticketTypeId?: string;
    id?: string;
    priceToBeSold?: number;
    minimumNumberOfTicketsToBeBought?: number;
  }[];
  setTicketTypes: (
    ticketTypes: {
      id: string;
      ticketType: EventTicketType;
      priceToBeSold?: number;
      minimumNumberOfTicketsToBeBought?: number;
    }[],
  ) => void;
}

const EventOfferPerMultipleTickets: FC<EventOfferPerMultipleTicketsProps> = ({
  tickets,
  ticketTypes,
  setTicketTypes,
}) => {
  const [discountType, setDiscountType] = useState<string>('%');

  return (
    <div className={s.wrapper}>
      <EventOfferSetTicketType
        offerType={OfferType.perMultipleNumberOfTickets}
        ticketTypes={ticketTypes}
        tickets={tickets}
        setTicketTypes={setTicketTypes}
      />
      <div className={s.row} style={{ marginTop: 16 }}>
        {/* This descriptive label is not directly tied to a specific input, so it's not wrapped in a Form.Item. */}
        <Label>
          When the offer depends on the number of tickets, leaving this field empty, means that the
          user would get X number of free tickets set in the field{' '}
          <b>Number of tickets to get a discount on</b>, whilst if you input anything the user will
          get a discount percentage on the number of tickets marked in the field{' '}
          <b>Number of tickets to get a discount on.</b>
        </Label>
      </div>
      <div className={s.row}>
        <div className={s.item}>
          <Label required>Number of tickets to get free tickets</Label>
          <Form.Item rules={[formRules.required]} name="numberOfTicketsToGetDiscount">
            <Input.Number
              style={{ width: '100%' }}
              type="number"
              name="numberOfTicketsToGetDiscount"
              size="large"></Input.Number>
          </Form.Item>
        </div>
        <div className={s.item}>
          <Label required>
            Number of tickets to get a discount on (please specify discount in discount field)
          </Label>
          <Form.Item rules={[formRules.required]} name="numberOfTicketsToGetDiscountOn">
            <Input.Number
              style={{ width: '100%' }}
              name="numberOfTicketsToGetDiscountOn"
              size="large"></Input.Number>
          </Form.Item>
        </div>
      </div>
      <div className={s.row}>
        <div className={s.item}>
          <Label required>Discount</Label>
          <Form.Item rules={[formRules.required]} name="fixedDiscount">
            <Input.Number
              style={{ width: '100%' }}
              name="fixedDiscount"
              size="middle"></Input.Number>
          </Form.Item>
        </div>
        <div className={s.item}>
          <Label>Type</Label>
          <Form.Item name="fixedDiscountValueType">
            <Select
              style={{ width: '100%', height: 40 }}
              onChange={(value) => setDiscountType(value)}
              options={[
                { value: 'percentage', label: '%' },
                { value: 'fixedValue', label: '€' },
              ]}
              value={discountType}
              defaultValue="percentage"
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default EventOfferPerMultipleTickets;
